import { createAction } from 'redux-actions';

import { Actions } from '../constants';

const mapPayload = (pageName = null) => ({ pageName });

const closeModal = createAction(Actions.CLOSE, mapPayload);

export default closeModal;
